import api from "@/api";
import { createLatestRequestGate, parseApiError, parseCollectionAuthorization } from "@/helpers/teamAuthorization";

const taxesRequestGate = createLatestRequestGate();

export default {
  state: {
      teamTaxes: [],
      collectionAuthorization: null,
      collectionError: null,
  },
  getters: {
      teamTaxes: (state) => state.teamTaxes,
      taxCollectionAuthorization: (state) => state.collectionAuthorization,
      taxCollectionError: (state) => state.collectionError,

  },
  mutations: {
    setTeamTaxes: (state, data) => {
      state.teamTaxes = data;
    },
    setTaxCollectionAuthorization: (state, data) => {
      state.collectionAuthorization = data;
    },
    setTaxCollectionError: (state, data) => {
      state.collectionError = data;
    },

  },
  actions: {
    getTeamTaxes: async ({ commit }, id) => {
      const teamId = Number(id);
      commit("setTeamTaxes", []);
      commit("setTaxCollectionAuthorization", null);
      commit("setTaxCollectionError", null);
      if (!Number.isInteger(teamId) || teamId <= 0) return;
      const requestKey = `taxes:${teamId}`;
      const { signal } = taxesRequestGate.start(requestKey);
      try {
        const response = await api({ requiresAuth: true }).get(`/v1/team-taxes/${teamId}`, { signal });
        if (!taxesRequestGate.isActive(requestKey)) return;
        const { data } = response.data;
        commit("setTeamTaxes", data);
        commit("setTaxCollectionAuthorization", parseCollectionAuthorization(response));
      } catch (err) {
        if (err.code === "ERR_CANCELED" || !taxesRequestGate.isActive(requestKey)) return;
        commit("setTaxCollectionError", parseApiError(err));
      }
    },
    updateTax: (
        { commit, dispatch},
        {
          id: id,
          rate,
          is_custom,
          is_fixed,
          team_id,
          group_name,
          name
        }
    ) =>
        new Promise((resolve, reject) => {
          api({ requiresAuth: true })
              .patch("/v1/taxes/" + id, {
                rate: rate,
                is_custom: is_custom,
                is_fixed: is_fixed,
                group_name: group_name,
                team_id: team_id,
                name: name
              })
              .then(
                  async (response) => {
                      const { data } = response.data;
                      commit("setTeamTaxesLoading", true);
                      await dispatch("getTeamTaxes", data.team.id);
                      resolve(data);
                      commit("setTeamTaxesLoading", false);
                  },
                  (err) => {
                    commit("setTeamTaxesLoading", false);
                    reject(err);
                  }
              );
        }),


    addTax: (
          { commit, dispatch},
          { 
            rate,
            is_custom,
            is_fixed,
            name,
            group_name,
            team_id,
          }
      ) =>
          new Promise((resolve, reject) => {
            api({ requiresAuth: true })
                .post("/v1/taxes", {
                  rate: rate,
                  is_custom: is_custom,
                  is_fixed: is_fixed,
                  name: name,
                  group_name: group_name,
                  team_id: team_id,
                })
                .then(
                    async (response) => {
                        const { data } = response.data;
                        commit("setTeamTaxesLoading", true);
                        await dispatch("getTeamTaxes", data.team.id);
                        resolve(data);
                        commit("setTeamTaxesLoading", false);
                    },
                    (err) => {
                      commit("setTeamTaxesLoading", false);
                      reject(err);
                    }
                );
          }),
    deleteTax: ({ commit, dispatch }, { id, teamId }) =>
      new Promise((resolve, reject) => {
        api({ requiresAuth: true })
          .delete(`/v1/taxes/${id}`, { data: { team_id: teamId } })
          .then(
            async () => {
              commit("setTeamTaxesLoading", true);
              await dispatch("getTeamTaxes", teamId);
              resolve();
              commit("setTeamTaxesLoading", false);
            },
            (err) => {
              commit("setTeamTaxesLoading", false);
              reject(err);
            }
          );
      }),
  },


};
